export const bacteriaLayoutConfig_toxin_eng = [

    {
        label: 'Bacillus genus',
        page: 12,
        yOffset: 230,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 220,
        yResult: 220,
        yResulttext: 224,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 12,
        yOffset: 269,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 259,
        yResult: 259,
        yResulttext: 263,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Clostridium difficile',
        page: 12,
        yOffset: 308,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 298,
        yResult: 298,
        yResulttext: 302,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 12,
        yOffset: 347,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 337,
        yResult: 337,
        yResulttext: 341,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 12,
        yOffset: 386,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 376,
        yResult: 376,
        yResulttext: 380,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 466,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 456,
        yResult: 456,
        yResulttext: 460,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 12,
        yOffset: 505,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 495,
        yResult: 495,
        yResulttext: 499,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 12,
        yOffset: 544,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 534,
        yResult: 534,
        yResulttext: 538,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 12,
        yOffset: 583,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 573,
        yResult: 573,
        yResulttext: 577,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 12,
        yOffset: 622,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 612,
        yResult: 612,
        yResulttext: 616,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 661,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 651,
        yResult: 651,
        yResulttext: 655,
        xResulttext: 585,
        show_result: true
    },
    {
        label: 'Bacillus genus',
        page: 16,
        yOffset: 130,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 120,
        yResult: 651,
        yResulttext: 124,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Candida albicans',
        page: 16,
        yOffset: 310,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 300,
        yResult: 651,
        yResulttext: 304,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Clostridium difficile',
        page: 16,
        yOffset: 504,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 494,
        yResult: 651,
        yResulttext: 498,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 16,
        yOffset: 675,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 665,
        yResult: 651,
        yResulttext: 669,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 16,
        yOffset: 875,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 865,
        yResult: 651,
        yResulttext: 869,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 17,
        yOffset: 130,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 120,
        yResult: 651,
        yResulttext: 124,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 17,
        yOffset: 490,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 480,
        yResult: 651,
        yResulttext: 484,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 17,
        yOffset: 780,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 770,
        yResult: 651,
        yResulttext: 774,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 18,
        yOffset: 98,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 88,
        yResult: 651,
        yResulttext: 92,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 18,
        yOffset: 380,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 370,
        yResult: 400,
        yResulttext: 374,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 18,
        yOffset: 600,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 590,
        yResult: 400,
        yResulttext: 594,
        xResulttext: 585,
        show_result: false
    },
];

export const bacteriaLayoutConfig_toxin_thai = [
    {
        label: 'Bacillus genus',
        page: 11,
        yOffset: 230,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 220,
        yResult: 220,
        yResulttext: 224,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 11,
        yOffset: 269,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 259,
        yResult: 259,
        yResulttext: 263,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Clostridium difficile',
        page: 11,
        yOffset: 308,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 298,
        yResult: 298,
        yResulttext: 302,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 11,
        yOffset: 347,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 337,
        yResult: 337,
        yResulttext: 341,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 11,
        yOffset: 386,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 376,
        yResult: 376,
        yResulttext: 380,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 466,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 456,
        yResult: 456,
        yResulttext: 460,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 11,
        yOffset: 505,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 495,
        yResult: 495,
        yResulttext: 499,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 11,
        yOffset: 544,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 534,
        yResult: 534,
        yResulttext: 538,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 11,
        yOffset: 583,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 573,
        yResult: 573,
        yResulttext: 577,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 11,
        yOffset: 622,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 612,
        yResult: 612,
        yResulttext: 616,
        xResulttext: 585,         
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 11,
        yOffset: 661,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 651,
        yResult: 651,
        yResulttext: 655,
        xResulttext: 585,
        show_result: true
    },
    {
        label: 'Bacillus genus',
        page: 15,
        yOffset: 148,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 138,
        yResult: 651,
        yResulttext: 142,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Candida albicans',
        page: 15,
        yOffset: 306,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 296,
        yResult: 651,
        yResulttext: 300,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Clostridium difficile',
        page: 15,
        yOffset: 504,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 494,
        yResult: 651,
        yResulttext: 498,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 15,
        yOffset: 681,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 671,
        yResult: 651,
        yResulttext: 675,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 15,
        yOffset: 878,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 868,
        yResult: 651,
        yResulttext: 872,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 16,
        yOffset: 142,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 132,
        yResult: 651,
        yResulttext: 136,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 16,
        yOffset: 507,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 497,
        yResult: 651,
        yResulttext: 502,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 16,
        yOffset: 780,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 770,
        yResult: 651,
        yResulttext: 774,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 17,
        yOffset: 112,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 102,
        yResult: 651,
        yResulttext: 106,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus paracasei',
        page: 17,
        yOffset: 332,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 322,
        yResult: 400,
        yResulttext: 326,
        xResulttext: 585,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 17,
        yOffset: 513,
        xLabel: 70,
        xBarStart: 300,
        xBarGap: 53,
        xResult: 685,
        yLabel: 503,
        yResult: 400,
        yResulttext: 507,
        xResulttext: 585,
        show_result: false
    },
];